<app-logo-only-header [secondaryLogoUrl]="partnerLogoUrl"></app-logo-only-header>

<div class="container-fluid content pre-approval-background-img" [style.backgroundImage]="backgroundUrl">
  <div class="col-xs-12 col-md-6 col-md-4 col-md-offset-7">
    <app-eligibility-check-form></app-eligibility-check-form>
  </div>
</div>
<div id="faq-section" class="container-fluid faq-section">
  <div>
    <div class="faq">
      <div class="col-12">
        <p class="faq-header-text finzy-blue">Frequently Asked Questions</p>
      </div>
    </div>
  </div>
  <div class="faq">
    <mat-accordion>
      <mat-expansion-panel class="faq">
        <mat-expansion-panel-header class="faq-query">
          <mat-panel-title>
            1. What is an Indicative Eligibility Check?
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="faq-content">The Indicative Eligibility Check helps you find out what personalised loan offers you may be eligble for.
          These personalised offers depend on your credit profile. If you like an offer and if you continue to apply for a loan,
          your application will still be subject to our standard credit approval process.
          For more information on how easy the process is on finzy <a target="_blank" [routerLink]="['/faq']">click
            here.</a>
        </p>
      </mat-expansion-panel>
      <mat-expansion-panel class="faq">
        <mat-expansion-panel-header class="faq-query">
          <mat-panel-title>
            2. What are you going to do with my information?
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="faq-content">We use the information to propose Indicative Loan Offers and to uniquely identify you for the next time you
          use our services. finzy assures you that your information is safe and secure. We use industry standards and physical, technical
          and administrative security measures
          to keep your Personal Information confidential and secure.</p>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
  <hr class="hrcust">
  <P class="faq-sub-text">Can’t find an answer? Call <b>9341 300 300</b> or Email <b>support@finzy.com</b></P>
</div>

